import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { BaseHistoryInfo } from './base-history-info';
import { CommentCharacterElementBox } from '../viewer/page';
import { CONTROL_CHARACTERS } from '../../base/types';
/**
 * EditorHistory preservation class
 */
/**
 * @private
 */
export class HistoryInfo extends BaseHistoryInfo {
    constructor(node, isChild) {
        super(node);
        /**
         * @private
         */
        this.isTrackingEnabled = undefined;
        this.isChildHistoryInfo = false;
        this.editRangeStart = undefined;
        this.documentHelper = node.documentHelper;
        this.isChildHistoryInfo = isChild;
    }
    get hasAction() {
        return !isNullOrUndefined(this.modifiedActions);
    }
    addModifiedAction(baseHistoryInfo) {
        // For complex actions such as Replace text, Insert/Remove Hyperlink etc.
        if (!(this.editorHistory.isUndoing || this.editorHistory.isRedoing)) {
            if (isNullOrUndefined(this.modifiedActions)) {
                this.modifiedActions = [];
            }
            this.modifiedActions.push(baseHistoryInfo);
        }
    }
    /**
     * @returns {Operation[]} returns an array of type Operations
     * @param {boolean} isInvertOperation accepts a boolean value
     * @private
     */
    getActionInfo(isInvertOperation) {
        const action = this.action;
        let operations = [];
        switch (action) {
            case 'Insert':
                for (let i = 0; i < this.modifiedActions.length; i++) {
                    const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                    operations.push(currentHistory.getInsertOperation(currentHistory.action));
                }
                break;
            case 'InsertContentControl':
                for (let i = 0; i < this.modifiedActions.length; i++) {
                    const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                    operations.push(currentHistory.getInsertOperation(currentHistory.action));
                }
                break;
            case 'InsertBookmark':
            case 'RestrictEditing':
                if (this.editorHistory.isUndoing) {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        if (action === 'RestrictEditing') {
                            this.modifiedActions[parseInt(i.toString(), 10)].markerData.push(this.owner.editorModule.getMarkerData(this.modifiedActions[parseInt(i.toString(), 10)].removedNodes[0]));
                        }
                        operations.push(this.modifiedActions[parseInt(i.toString(), 10)].getDeleteOperation('DeleteBookmark', i === 0 ? true : undefined));
                        this.modifiedActions[parseInt(i.toString(), 10)].markerData.shift();
                    }
                }
                else {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        if (currentHistory.action === 'DeleteBookmark') {
                            operations.push(currentHistory.getDeleteOperation('DeleteBookmark'));
                            operations.push(currentHistory.getDeleteOperation('DeleteBookmark', true));
                            continue;
                        }
                        operations.push(currentHistory.getInsertOperation(action));
                    }
                }
                break;
            case 'BackSpace':
            case 'Delete':
            case 'RemoveEditRange':
                if (this.editorHistory.isUndoing) {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        if (currentHistory.action === 'InsertInline') {
                            const operation = currentHistory.getDeleteOperation('DeleteBookmark', true);
                            operations.push(operation);
                        }
                        else {
                            const operationCollection = currentHistory.getActionInfo();
                            operations = [...operations, ...operationCollection];
                            if (currentHistory.action === 'RemoveEditRange') {
                                operations.push(currentHistory.getDeleteOperation(action, true));
                            }
                        }
                    }
                    operations.reverse();
                }
                else {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        if (currentHistory.action === 'InsertInline') {
                            const operation = currentHistory.getInsertOperation('InsertBookmark');
                            operations.push(operation);
                        }
                        else {
                            operations.push(currentHistory.getDeleteOperation(action));
                            if (currentHistory.action === 'RemoveEditRange') {
                                operations.push(currentHistory.getDeleteOperation(action, true));
                            }
                        }
                    }
                }
                break;
            case 'PageBreak':
            case 'ColumnBreak':
                if (this.owner.enableTrackChanges) {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        if (currentHistory.removedNodes.length > 0) {
                            operations = operations.concat(currentHistory.getDeleteOperationsForTrackChanges());
                        }
                        const markerData = currentHistory.markerData[currentHistory.markerData.length - 1];
                        const operation = currentHistory.getInsertOperation('Enter');
                        const breakOperation = this.getInsertOperation(action);
                        operation.markerData = markerData;
                        breakOperation.markerData = {
                            author: markerData.author,
                            date: markerData.date,
                            revisionType: markerData.revisionType
                        };
                        operations.push(operation);
                        if (action === 'ColumnBreak') {
                            operations.push(operation);
                        }
                        operations.push(breakOperation);
                        operation.markerData.skipOperation = true;
                    }
                }
                else {
                    if (this.editorHistory.isUndoing) {
                        for (let i = 0; i < this.modifiedActions.length; i++) {
                            const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                            currentHistory.endIndex = currentHistory.startIndex;
                            //Basically for pagebreak and column break there will one paragraph and one page break textelementbox difference. So for transformation we sended two backspace operation.
                            operations.push(currentHistory.getDeleteOperation('Delete'));
                            operations.push(currentHistory.getDeleteOperation('Delete'));
                            if (action === 'ColumnBreak') {
                                operations.push(currentHistory.getDeleteOperation('Delete'));
                            }
                            if (currentHistory.isRemovedNodes) {
                                const operationCollection = currentHistory.getDeleteContent('BackSpace');
                                operations = [...operations, ...operationCollection];
                            }
                        }
                    }
                    else {
                        for (let i = 0; i < this.modifiedActions.length; i++) {
                            const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                            if (currentHistory.removedNodes.length > 0) {
                                operations.push(currentHistory.getDeleteOperation(action));
                            }
                        }
                        const operation = this.getInsertOperation('Enter');
                        operation.markerData = { skipOperation: true };
                        //Basically for pagebreak and column break there will one paragraph and page break textelementbox difference. So for transformation we sended two insert operation.
                        operations.push(operation);
                        if (action === 'ColumnBreak') {
                            operations.push(operation);
                        }
                        operations.push(this.getInsertOperation(action));
                    }
                }
                break;
            case 'InsertHyperlink':
            case 'AutoFormatHyperlink':
            case 'RemoveHyperlink':
                if (this.editorHistory.isUndoing && action === 'RemoveHyperlink') {
                    let length = 0;
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        if (currentHistory.action === 'FontColor' || currentHistory.action === 'Underline') {
                            length = currentHistory.endIndex - currentHistory.startIndex;
                        }
                    }
                    if (!isNullOrUndefined(this.modifiedActions[parseInt((this.modifiedActions.length - 1).toString(), 10)].fieldBegin)) {
                        this.modifiedActions[parseInt((this.modifiedActions.length - 1).toString(), 10)].endIndex =
                            this.modifiedActions[parseInt((this.modifiedActions.length - 1).toString(), 10)].startIndex + length;
                        const operation = this.modifiedActions[parseInt((this.modifiedActions.length - 1).toString(), 10)].getDeleteOperation('Delete');
                        operation.markerData = undefined;
                        operations.push(operation);
                        const operationCollection = this.modifiedActions[parseInt((this.modifiedActions.length - 1).toString(), 10)].getFieldOperation();
                        operations = [...operations, ...operationCollection];
                    }
                }
                else {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        if (currentHistory.action === 'InsertHyperlink') {
                            operations.push(...currentHistory.getActionInfo());
                        }
                        else if (currentHistory.action === 'InsertInline') {
                            if (currentHistory.insertedText === CONTROL_CHARACTERS.Marker_Start ||
                                currentHistory.insertedText === CONTROL_CHARACTERS.Marker_End) {
                                if (this.editorHistory.isUndoing) {
                                    operations.push(currentHistory.getDeleteOperation(currentHistory.action));
                                }
                                else {
                                    operations.push(currentHistory.getInsertOperation('InsertHyperlink'));
                                }
                            }
                            else {
                                if (this.editorHistory.isUndoing) {
                                    operations.push(currentHistory.getDeleteOperation(currentHistory.action));
                                }
                                else {
                                    operations.push(currentHistory.getInsertOperation('Insert'));
                                }
                            }
                        }
                        else if (currentHistory.action === 'Delete') {
                            operations.push(currentHistory.getDeleteOperation(currentHistory.action));
                        }
                        else if (currentHistory.action === 'Underline') {
                            operations = operations.concat(currentHistory.getActionInfo());
                        }
                        else if (currentHistory.action === 'FontColor') {
                            operations = operations.concat(currentHistory.getActionInfo());
                        }
                    }
                    if (this.editorHistory.isUndoing) {
                        operations.reverse();
                    }
                }
                break;
            case 'InsertComment':
                if (this.editorHistory.isUndoing) {
                    this.getDeleteCommentOperation(this.modifiedActions, operations);
                }
                else {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        let operation = currentHistory.getInsertOperation(currentHistory.action);
                        if ((currentHistory.insertedElement instanceof CommentCharacterElementBox && currentHistory.action === 'InsertInline')) {
                            operations.push(currentHistory.getCommentOperation(operation, currentHistory.action));
                        }
                        else if (currentHistory.action === 'InsertCommentWidget') {
                            operation = this.getUpdateOperation();
                            operations.push(currentHistory.getCommentOperation(operation, currentHistory.action));
                        }
                    }
                }
                break;
            case 'RemoveComment':
                if (this.editorHistory.isUndoing) {
                    for (let i = this.modifiedActions.length - 1; i >= 0; i--) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        let operation = undefined;
                        let operationCollection = [];
                        if (currentHistory.action === 'InsertInline' && currentHistory.insertedElement instanceof CommentCharacterElementBox) {
                            operation = currentHistory.getDeleteOperation(currentHistory.action);
                            operationCollection.push(currentHistory.getCommentOperation(operation, 'InsertInline'));
                        }
                        else if (currentHistory.action === 'RemoveInline') {
                            operation = currentHistory.getDeleteOperation(currentHistory.action);
                            operationCollection.push(currentHistory.getCommentOperation(operation, 'InsertInline'));
                            operation = currentHistory.getInsertOperation(currentHistory.action);
                            operationCollection.push(currentHistory.getCommentOperation(operation, 'InsertInline'));
                        }
                        else if (currentHistory.action === 'DeleteComment') {
                            operationCollection = currentHistory.getActionInfo();
                        }
                        else {
                            this.owner.sfdtExportModule.iscontentInsert = false;
                            operationCollection = currentHistory.getActionInfo();
                            this.owner.sfdtExportModule.iscontentInsert = true;
                        }
                        operations = [...operations, ...operationCollection];
                    }
                }
                else {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        let operation = undefined;
                        let operationCollection = [];
                        if (currentHistory.action === 'RemoveInline' && currentHistory.removedNodes[0] instanceof CommentCharacterElementBox) {
                            operation = currentHistory.getDeleteOperation(currentHistory.action);
                            operationCollection.push(currentHistory.getCommentOperation(operation, currentHistory.action));
                        }
                        else if (currentHistory.action === 'InsertInline' && currentHistory.insertedElement instanceof CommentCharacterElementBox) {
                            operation = currentHistory.getInsertOperation(currentHistory.action);
                            operationCollection.push(currentHistory.getCommentOperation(operation, currentHistory.action));
                        }
                        else {
                            operationCollection = currentHistory.getActionInfo();
                        }
                        operations = [...operations, ...operationCollection];
                    }
                }
                break;
            case 'DeleteComment':
                if (this.editorHistory.isUndoing) {
                    for (let j = this.modifiedActions.length - 1; j >= 0; j--) {
                        const history = this.modifiedActions[parseInt(j.toString(), 10)];
                        let operation = history.getInsertOperation(history.action);
                        if ((history.insertedElement instanceof CommentCharacterElementBox && history.action === 'RemoveInline')) {
                            operations.push(history.getCommentOperation(operation, 'InsertInline'));
                        }
                        else if (history.action === 'DeleteCommentWidget') {
                            operation = this.getUpdateOperation();
                            operations.push(history.getCommentOperation(operation, 'InsertCommentWidget'));
                        }
                        else if (history.action === 'DeleteComment') {
                            history.getActionInfo();
                        }
                    }
                }
                else {
                    this.getDeleteCommentOperation(this.modifiedActions, operations);
                }
                break;
            case 'FormField': {
                const currentHistory = this.modifiedActions.pop();
                operations = currentHistory.getFieldOperation();
                break;
            }
            case 'IMEInput':
                if (isInvertOperation && (!(this.editorHistory.isUndoing || this.editorHistory.isRedoing))) {
                    if (this.modifiedActions[0].removedNodes.length > 0) {
                        const removeOperation = this.modifiedActions[0].getDeleteOperation('Delete');
                        removeOperation.length = removeOperation.text.length;
                        operations.push(removeOperation);
                    }
                    const insertOperation = this.modifiedActions[this.modifiedActions.length - 1].getInsertOperation('Insert');
                    insertOperation.length = insertOperation.text.length;
                    operations.push(insertOperation);
                    operations.reverse();
                    for (let i = 0; i < operations.length; i++) {
                        const operation = operations[parseInt(i.toString(), 10)];
                        if (operation.action === 'Insert') {
                            operation.action = 'Delete';
                        }
                        else if (operation.action === 'Delete') {
                            operation.action = 'Insert';
                        }
                    }
                }
                else {
                    let currentHistory = this.modifiedActions[this.modifiedActions.length - 1];
                    if (this.editorHistory.isUndoing || this.editorHistory.isRedoing) {
                        for (let i = 0; i < this.modifiedActions.length; i++) {
                            currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                            if (currentHistory.removedNodes.length > 0) {
                                operations.push(currentHistory.getDeleteOperation(action));
                            }
                            if (currentHistory.isRemovedNodes) {
                                const operationCollection = currentHistory.getDeleteContent('BackSpace');
                                operations = [...operations, ...operationCollection];
                            }
                            currentHistory.isRemovedNodes = false;
                        }
                    }
                    else {
                        if (currentHistory.removedNodes.length > 0) {
                            operations.push(currentHistory.getDeleteOperation(action));
                        }
                        operations.push(currentHistory.getInsertOperation(this.action));
                    }
                    currentHistory.isRemovedNodes = false;
                }
                break;
            case 'Accept All':
            case 'ReplaceAll':
            case 'Reject All': {
                let isSkip = false;
                if (this.editorHistory.isUndoing) {
                    for (let i = this.modifiedActions.length - 1; i >= 0; i--) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        if (!isNullOrUndefined(currentHistory.cellOperation) && currentHistory.cellOperation.length > 0) {
                            operations.push(currentHistory.cellOperation[0]);
                            isSkip = true;
                            currentHistory.cellOperation = [];
                        }
                        else {
                            const operationsCollection = currentHistory.getActionInfo();
                            operations.push(...operationsCollection);
                        }
                    }
                }
                else {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                        if (currentHistory.action === 'RemoveRowTrack' && !isNullOrUndefined(currentHistory.cellOperation) && currentHistory.cellOperation.length > 0) {
                            operations.push(currentHistory.cellOperation[0]);
                            isSkip = true;
                            currentHistory.cellOperation = [];
                        }
                        else {
                            const operationsCollection = currentHistory.getActionInfo();
                            operations.push(...operationsCollection);
                        }
                    }
                }
                // if (!isSkip && (action === 'Accept All' || action === 'Reject All')) {
                //     operations.reverse();
                // }
                break;
            }
            case 'Paste':
                for (let i = 0; i < this.modifiedActions.length; i++) {
                    const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                    currentHistory.type = this.type === 'PasteToc' ? this.type : 'Paste';
                    const pasteOperations = currentHistory.getActionInfo();
                    operations.push(...pasteOperations);
                }
                break;
            case 'TOC':
                if (this.modifiedActions) {
                    if (this.editorHistory.isUndoing) {
                        for (let i = this.modifiedActions.length - 1; i >= 0; i--) {
                            const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                            currentHistory.type = currentHistory.action === 'Paste' ? 'PasteToc' : undefined;
                            const tocOperations = currentHistory.getActionInfo();
                            operations.push(...tocOperations);
                        }
                    }
                    else {
                        for (let i = 0; i < this.modifiedActions.length; i++) {
                            const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                            currentHistory.type = currentHistory.action === 'Paste' ? 'PasteToc' : undefined;
                            const tocOperations = currentHistory.getActionInfo();
                            operations.push(...tocOperations);
                        }
                    }
                }
                break;
            case 'DragAndDropContent':
                for (let i = 0; i < this.modifiedActions.length; i++) {
                    const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                    currentHistory.type = currentHistory.action === 'Paste' ? 'Paste' : undefined;
                    const ddcOperations = currentHistory.getActionInfo();
                    operations.push(...ddcOperations);
                }
                break;
            case 'ClearFormat':
                if (this.editorHistory.isUndoing) {
                    for (let i = 0; i < this.modifiedActions.length; i++) {
                        operations.push(...this.modifiedActions[parseInt(i.toString(), 10)].modifiedFormatOperation);
                        this.modifiedActions[parseInt(i.toString(), 10)].modifiedFormatOperation = [];
                    }
                }
                else {
                    const clearHistory = this.modifiedActions[this.modifiedActions.length - 1];
                    const formatOperation = clearHistory.buildFormatOperation('ClearFormat', true);
                    operations = formatOperation.slice();
                }
                break;
            case 'ApplyStyle': {
                let styleHistory;
                let formatstyleOperation = [];
                if (this.modifiedActions[0] instanceof HistoryInfo) {
                    const historyInfo = this.modifiedActions[0];
                    styleHistory = historyInfo.modifiedActions[0];
                    formatstyleOperation = styleHistory.buildFormatOperation('ClearFormat', true);
                    operations = formatstyleOperation.slice();
                }
                if (!(this.modifiedActions[this.modifiedActions.length - 1] instanceof HistoryInfo)) {
                    formatstyleOperation = this.modifiedActions[this.modifiedActions.length - 1].buildFormatOperation(action, true);
                    for (let i = 0; i < formatstyleOperation.length; i++) {
                        operations.push(formatstyleOperation[parseInt(i.toString(), 10)]);
                    }
                }
                break;
            }
            case 'TableMarginsSelection':
                this.modifiedActions[this.modifiedActions.length - 1].createTableFormat(this.modifiedActions[this.modifiedActions.length - 1].action);
                this.modifiedActions[this.modifiedActions.length - 1].type = 'TableFormat';
                operations.push(this.modifiedActions[this.modifiedActions.length - 1].getFormatOperation());
                break;
            case 'BordersAndShading':
                if (this.modifiedActions[0].action === 'TableFormat') {
                    this.modifiedActions[0].type = 'TableFormat';
                    this.modifiedActions[0].createTableFormat('BordersAndShading');
                    operations.push(this.modifiedActions[0].getFormatOperation());
                }
                else {
                    this.modifiedActions[0].createCellFormat('BordersAndShading');
                    this.modifiedActions[0].type = 'CellFormat';
                    operations = this.modifiedActions[0].getSelectedCellOperation('BordersAndShading', undefined, true, true, true);
                }
                break;
            case 'AutoList':
                for (let i = 0; i < this.modifiedActions.length; i++) {
                    const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                    const autoListOperations = currentHistory.getActionInfo();
                    operations.push(...autoListOperations);
                }
                break;
            case 'TableProperties':
                for (let i = 0; i < this.modifiedActions.length; i++) {
                    const tablePropHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                    if (tablePropHistory.action === 'TableFormat') {
                        tablePropHistory.createTableFormat(tablePropHistory.action);
                        tablePropHistory.type = 'TableFormat';
                        operations.push(tablePropHistory.getFormatOperation());
                    }
                    else if (tablePropHistory.action === 'RowFormat') {
                        if (this.editorHistory.isUndoing || this.editorHistory.isRedoing &&
                            tablePropHistory.modifiedProperties.length > 1) {
                            operations = tablePropHistory.modifiedFormatOperation;
                            tablePropHistory.modifiedFormatOperation = [];
                        }
                        else {
                            tablePropHistory.createRowFormat(tablePropHistory.action);
                            tablePropHistory.type = 'RowFormat';
                            operations.push(tablePropHistory.getFormatOperation());
                        }
                    }
                    else if (tablePropHistory.action === 'CellFormat') {
                        tablePropHistory.createCellFormat(tablePropHistory.action);
                        tablePropHistory.type = 'CellFormat';
                        const cellProp = tablePropHistory.getSelectedCellOperation(tablePropHistory.action, false, false, false, true);
                        for (let i = 0; i < cellProp.length; i++) {
                            operations.push(cellProp[parseInt(i.toString(), 10)]);
                        }
                    }
                }
                break;
            case 'CellMarginsSelection':
                this.modifiedActions[this.modifiedActions.length - 1].createCellFormat('CellOptions');
                this.modifiedActions[this.modifiedActions.length - 1].type = 'CellFormat';
                operations = this.modifiedActions[this.modifiedActions.length - 1].getSelectedCellOperation('CellOptions', false, false, false, true).slice();
                break;
            case 'Reject Change':
                for (let i = 0; i < this.modifiedActions.length; i++) {
                    const currentHistory = this.modifiedActions[parseInt(i.toString(), 10)];
                    const operation = currentHistory.getActionInfo();
                    operations.push(...operation);
                }
                break;
        }
        return operations;
    }
    revert() {
        this.editorHistory.currentHistoryInfo = this;
        if (this.action === 'BordersAndShading') {
            this.owner.editorModule.isBordersAndShadingDialog = true;
        }
        if (!isNullOrUndefined(this.modifiedActions)) {
            if (this.editorHistory.isUndoing) {
                let i = this.modifiedActions.length;
                while (i > 0) {
                    const baseHistoryInfo = this.modifiedActions[i - 1];
                    baseHistoryInfo.revert();
                    i = i - 1;
                }
            }
            else {
                let i = 0;
                while (i < this.modifiedActions.length) {
                    const baseHistoryInfo = this.modifiedActions[parseInt(i.toString(), 10)];
                    baseHistoryInfo.revert();
                    i = i + 1;
                }
            }
        }
        if (this.action === 'RestrictEditing') {
            const user = this.editRangeStart.user !== '' ? this.editRangeStart.user : this.editRangeStart.group;
            if (this.editorHistory.isUndoing) {
                const index = this.owner.documentHelper.editRanges.get(user).indexOf(this.editRangeStart);
                if (index !== -1) {
                    this.owner.documentHelper.editRanges.get(user).splice(index, 1);
                }
            }
            else {
                this.owner.editorModule.updateRangeCollection(this.editRangeStart, user);
            }
            this.owner.selectionModule.updateEditRangeCollection();
        }
        if (this.action === 'Accept All' || this.action === 'Reject All') {
            let startTextPosition;
            let endTextPosition;
            if (this.editorHistory.isUndoing) {
                startTextPosition = !isNullOrUndefined(this.selectionStart)
                    ? this.owner.selectionModule.getTextPosBasedOnLogicalIndex(this.selectionStart) : undefined;
                endTextPosition = !isNullOrUndefined(this.selectionEnd)
                    ? this.owner.selectionModule.getTextPosBasedOnLogicalIndex(this.selectionEnd) : undefined;
            }
            else {
                startTextPosition = !isNullOrUndefined(this.insertPosition)
                    ? this.owner.selectionModule.getTextPosBasedOnLogicalIndex(this.insertPosition) : undefined;
                endTextPosition = !isNullOrUndefined(this.endPosition)
                    ? this.owner.selectionModule.getTextPosBasedOnLogicalIndex(this.endPosition) : undefined;
            }
            if (startTextPosition && endTextPosition) {
                this.owner.selectionModule.selectRange(startTextPosition, endTextPosition);
            }
        }
        if (!this.isChildHistoryInfo) {
            this.editorHistory.updateComplexHistory();
        }
        else {
            this.editorHistory.updateComplexHistoryInternal();
        }
    }
    destroy() {
        if (!isNullOrUndefined(this.modifiedActions)) {
            while (this.modifiedActions.length > 0) {
                const baseHistoryInfo = this.modifiedActions[this.modifiedActions.length - 1];
                baseHistoryInfo.destroy();
                this.modifiedActions.splice(this.modifiedActions.indexOf(baseHistoryInfo), 1);
            }
            this.modifiedActions = undefined;
        }
        super.destroy();
    }
}
